import _objectWithoutPropertiesLoose from '@babel/runtime/helpers/objectWithoutPropertiesLoose';
import _extends from '@babel/runtime/helpers/extends';
import { jsx, Global } from '@emotion/core';
import React, { Fragment, Component } from 'react';
import { DialogOverlay, DialogContent } from '@reach/dialog';
import { animated, useTransition } from '@xkit/spring';
import _css from '@emotion/css';
import _inheritsLoose from '@babel/runtime/helpers/inheritsLoose';
import ReactDOM from 'react-dom';
import Button from '@xkit/button';
import { IS_BROWSER } from '@swiftcarrot/utils';

var defaultStyles = {
  transitionConfig: {
    spring: {
      from: {
        opacity: 0,
        scale: 0.8
      },
      enter: {
        opacity: 1,
        scale: 1
      },
      leave: {
        opacity: 0,
        scale: 0.8
      },
      config: {
        friction: 26,
        tension: 250,
        clamp: true
      }
    },
    overlay: function overlay(_ref) {
      var opacity = _ref.opacity;
      return {
        opacity: opacity
      };
    },
    dialog: function dialog(_ref2) {
      var scale = _ref2.scale;
      return {
        transform: scale.interpolate(function (s) {
          return "scale(" + s + ")";
        })
      };
    }
  },
  overlay: {
    background: 'hsla(0, 0%, 0%, 0.33)',
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    overflow: 'auto',
    zIndex: 20
  },
  ovelayOpen: {},
  overlayCentered: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    background: 'hsla(0, 0%, 0%, 0.33)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  dialog: {
    maxWidth: 500,
    marginTop: 80,
    backgroundColor: '#fff',
    marginLeft: 'auto',
    marginRight: 'auto',
    borderRadius: 8,
    outline: 'none'
  },
  dialogOpen: {},
  dialogCentered: {
    backgroundColor: '#fff',
    borderRadius: 8,
    outline: 'none'
  },
  header: {
    fontWeight: '600',
    fontSize: 18,
    padding: 15,
    alignItems: 'center',
    display: 'flex',
    borderBottom: '1px solid #ececec'
  },
  body: {
    padding: 15
  },
  footer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    padding: '12px 15px',
    borderTop: '1px solid #ececec'
  }
};

var AnimatedOverlay = animated(DialogOverlay);
var AnimatedContent = animated(DialogContent);

var Dialog = function Dialog(_ref) {
  var customStyles = _ref.styles,
      onDismiss = _ref.onDismiss,
      centered = _ref.centered,
      children = _ref.children,
      isOpen = _ref.isOpen;
  var styles = centered ? {
    overlay: [_extends({}, defaultStyles.overlayCentered, customStyles.overlayCentered)],
    dialog: [_extends({}, defaultStyles.dialogCentered, customStyles.dialogCentered)]
  } : {
    overlay: [_extends({}, defaultStyles.overlay, customStyles.overlay), isOpen && _extends({}, defaultStyles.overlayOpen, customStyles.overlayOpen)],
    dialog: [_extends({}, defaultStyles.dialog, customStyles.dialog), isOpen && _extends({}, defaultStyles.dialogOpen, customStyles.dialogOpen)]
  };
  var transitionConfig = customStyles.transitionConfig || defaultStyles.transitionConfig;
  var transitions = useTransition(isOpen, null, transitionConfig.spring);

  function renderDialog() {
    if (typeof customStyles.transitionConfig !== 'undefined' && (customStyles.transitionConfig == null || customStyles.transitionConfig === false)) {
      return isOpen && jsx(DialogOverlay, {
        css: styles.overlay,
        onDismiss: onDismiss
      }, jsx(DialogContent, {
        css: styles.dialog
      }, children));
    }

    return transitions.map(function (_ref2) {
      var isOpen = _ref2.item,
          props = _ref2.props,
          key = _ref2.key;
      return isOpen && jsx(AnimatedOverlay, {
        style: transitionConfig.overlay(props),
        css: styles.overlay,
        key: key,
        onDismiss: onDismiss
      }, jsx(AnimatedContent, {
        css: styles.dialog,
        style: transitionConfig.dialog(props)
      }, children));
    });
  }

  return jsx(Fragment, null, jsx(Global, {
    styles: {
      ':root': {
        '--reach-dialog': 1
      }
    }
  }), renderDialog());
}; // todo: dismissabble


Dialog.defaultProps = {
  centered: false,
  styles: {}
};
var DialogBody = function DialogBody(_ref3) {
  var customStyles = _ref3.styles,
      children = _ref3.children,
      props = _objectWithoutPropertiesLoose(_ref3, ["styles", "children"]);

  var styles = {
    body: [defaultStyles.body, customStyles.body]
  };
  return jsx("div", _extends({}, props, {
    css: styles.body
  }), children);
};
DialogBody.defaultProps = {
  styles: {}
};
var DialogFooter = function DialogFooter(_ref4) {
  var customStyles = _ref4.styles,
      children = _ref4.children,
      props = _objectWithoutPropertiesLoose(_ref4, ["styles", "children"]);

  var styles = {
    footer: [defaultStyles.footer, customStyles.footer]
  };
  return jsx("div", _extends({}, props, {
    css: styles.footer
  }), children);
};
DialogFooter.defaultProps = {
  styles: {}
};

var _ref = {
  name: "yyswcu",
  styles: "margin-left:auto;cursor:pointer;"
};

var DialogHeader = function DialogHeader(_ref2) {
  var children = _ref2.children,
      onDismiss = _ref2.onDismiss,
      customStyles = _ref2.styles,
      props = _objectWithoutPropertiesLoose(_ref2, ["children", "onDismiss", "styles"]);

  return jsx("div", _extends({}, props, {
    css:
    /*#__PURE__*/
    _css([defaultStyles.header, customStyles.header])
  }), children, onDismiss ? jsx("div", {
    onClick: onDismiss,
    css: _ref
  }, "\xD7") : null);
};

DialogHeader.defaultProps = {
  styles: {}
};

var container = null;
var openConfirm = null;

var ConfirmDialog =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(ConfirmDialog, _Component);

  function ConfirmDialog(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.open = function (_ref) {
      var title = _ref.title,
          content = _ref.content,
          onOK = _ref.onOK,
          onCancel = _ref.onCancel;

      _this.setState({
        isOpen: true,
        title: title,
        content: content,
        onOK: onOK,
        onCancel: onCancel
      });
    };

    _this.ok = function () {
      _this.setState({
        isOpen: false
      });

      if (_this.state.onOK) {
        _this.state.onOK();
      }
    };

    _this.cancel = function () {
      _this.setState({
        isOpen: false
      });

      if (_this.state.onCancel) {
        _this.state.onCancel();
      }
    };

    props.bindOpen(_this.open);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  var _proto = ConfirmDialog.prototype;

  _proto.render = function render() {
    var _this$state = this.state,
        isOpen = _this$state.isOpen,
        title = _this$state.title,
        content = _this$state.content;
    return React.createElement(Dialog, {
      isOpen: isOpen
    }, React.createElement(DialogHeader, null, title), React.createElement(DialogBody, null, content), React.createElement(DialogFooter, null, React.createElement(Button, {
      onClick: this.cancel
    }, "\u53D6\u6D88"), React.createElement(Button, {
      appearance: "primary",
      onClick: this.ok,
      style: {
        marginLeft: 8
      }
    }, "\u786E\u5B9A")));
  };

  return ConfirmDialog;
}(Component);

function init() {
  if (!IS_BROWSER) return;
  container = document.createElement('div');
  document.body.appendChild(container);
  ReactDOM.render(React.createElement(ConfirmDialog, {
    bindOpen: function bindOpen(open) {
      openConfirm = open;
    }
  }), container);
}

var confirm = function confirm(title, content, options) {
  return new Promise(function (resolve, reject) {
    if (openConfirm) {
      openConfirm({
        title: title,
        content: content,
        onOK: resolve,
        onCancel: reject,
        options: options
      });
    }
  });
};

init();

var container$1 = null;
var openAlert = null;

var AlertDialog =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(AlertDialog, _Component);

  function AlertDialog(props) {
    var _this;

    _this = _Component.call(this, props) || this;

    _this.open = function (_ref) {
      var title = _ref.title,
          content = _ref.content,
          onOK = _ref.onOK;

      _this.setState({
        isOpen: true,
        title: title,
        content: content,
        onOK: onOK
      });
    };

    _this.ok = function () {
      _this.setState({
        isOpen: false
      });

      if (_this.state.onOK) {
        _this.state.onOK();
      }
    };

    props.bindOpen(_this.open);
    _this.state = {
      isOpen: false
    };
    return _this;
  }

  var _proto = AlertDialog.prototype;

  _proto.render = function render() {
    var _this$state = this.state,
        isOpen = _this$state.isOpen,
        title = _this$state.title,
        content = _this$state.content;
    return React.createElement(Dialog, {
      isOpen: isOpen
    }, React.createElement(DialogHeader, null, title), React.createElement(DialogBody, null, content), React.createElement(DialogFooter, null, React.createElement(Button, {
      appearance: "primary",
      onClick: this.ok
    }, "\u786E\u5B9A")));
  };

  return AlertDialog;
}(Component);

function init$1() {
  if (!IS_BROWSER) return;
  container$1 = document.createElement('div');
  document.body.appendChild(container$1);
  ReactDOM.render(React.createElement(AlertDialog, {
    bindOpen: function bindOpen(open) {
      openAlert = open;
    }
  }), container$1);
}

var alert = function alert(title, content) {
  return new Promise(function (resolve) {
    if (openAlert) {
      openAlert({
        title: title,
        content: content,
        onOK: resolve
      });
    }
  });
};

init$1();

export default Dialog;
export { DialogBody, DialogFooter, DialogHeader, alert, confirm };
